import React from "react";
import { IoLocationOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "../../Style/PropertyListing/Buyproperty.css";

// Reusable, data-driven property card (replaces the static placeholder cards).
// Mirrors the markup used by Components/PropertyFilters/Filterproparty.js so the
// look-and-feel is identical to the working filter pages.
const PropertyCard = ({ item }) => {
  const navigation = useNavigate();

  const {
    id,
    property_id,
    property_type,
    price,
    price_in_text,
    suburb,
    property_images,
  } = item;

  const cardId = id || property_id;
  const image = Array.isArray(property_images) ? property_images[0] : property_images;

  const trimPrice = (str) => String(str).replace(/\.0+$/, "");
  const prettyType = (t) => String(t).replace(/_/g, " ");

  return (
    <div
      className="col-lg-3 col-md-6 col-sm-6 col-12 mt-3"
      onClick={() => cardId && navigation(`/property-detail_${cardId}`)}
    >
      <div className="Buying_card" style={{ cursor: cardId ? "pointer" : "default" }}>
        {image && <img src={image} alt={property_type || "property"} />}
        <div className="card_content">
          {property_type && (
            <h5
              className="m-0 text-capitalize"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              {prettyType(property_type)}
            </h5>
          )}
          {suburb && (
            <span>
              <IoLocationOutline /> {suburb}
            </span>
          )}
          {price ? (
            <p className="m-0">${trimPrice(price)}</p>
          ) : price_in_text ? (
            <p
              className="m-0"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              {price_in_text}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
